import TypescriptSingleFile from './typescript-single-file/config';
import TypescriptMultiFile from './typescript-multi-file/config';

export { TypescriptSingleFile, TypescriptMultiFile };

export { GeneratorConfig, EInputType } from './types';
export { getGeneratorConfig, definitions } from './get-generator';
